import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { AR_REPORTS_API } from "./apiRoutes";

interface UseGetARPropertyReportProps {
  communityId: string;
  reportDate?: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getARPropertyReport = async (communityId: string, reportDate?: any) =>
  await axiosAuth.get(
    reportDate
      ? `${AR_REPORTS_API(communityId)}/property?reportDate=${reportDate}`
      : `${AR_REPORTS_API(communityId)}/property`
  );

const useGetARPropertyReport = ({
  communityId,
  reportDate,
  queryParams,
}: UseGetARPropertyReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ar-360-reports-property", communityId],
    queryFn: () => getARPropertyReport(communityId, reportDate),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetARPropertyReport;
